/**
 * <crossword-input>
 * -----------------------------------------------------------------------------
 *
 * @type {Component}
 *
 * -----------------------------------------------------------------------------
 */

parasails.registerComponent('crossword-input', {

  //  ╔═╗╦ ╦╔╗ ╦  ╦╔═╗  ╔═╗╦═╗╔═╗╔═╗╔═╗
  //  ╠═╝║ ║╠╩╗║  ║║    ╠═╝╠╦╝║ ║╠═╝╚═╗
  //  ╩  ╚═╝╚═╝╩═╝╩╚═╝  ╩  ╩╚═╚═╝╩  ╚═╝
  props: [
    'inputletters',
    'hinttext',
    'crosswordindex',
    'questionnumber',
    'hintsmessage'
  ],

  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╦╔╗╔╔╦╗╔═╗╦═╗╔╗╔╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ║║║║ ║ ║╣ ╠╦╝║║║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╩╝╚╝ ╩ ╚═╝╩╚═╝╚╝╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: function () {
    return {
      inputtextstring: '',
      inputtext: []
    };
  },


  //  ╦ ╦╔╦╗╔╦╗╦
  //  ╠═╣ ║ ║║║║
  //  ╩ ╩ ╩ ╩ ╩╩═╝

  template: `<modal hideCloseButton=true class="modalinputbg">
    <div class="modal-header">
      <h5 class="explain-text" style="color: black"><pre>{{hintsmessage}}</pre></h5><br />
      <h5 class="modal-title">{{hinttext}}</h5>
    </div>
    <div class="modal-body inputPanel">
      <input class="crosswordinputtext" :maxlength="inputletters" v-model="inputtextstring">
      <!-- <div v-for="index in parseInt(inputletters)" :key="index">
        <div class="square letter">
            <input class="crosswordinput" maxlength="1" :id="'input_' + (index - 1)">
        </div>
      </div> -->
    </div>
    <div class="modal-footer">
      <button class="btn btn-crossword-input btn-secondary mr-1" @click="cancelInput">キャンセル</button>
      <button class="btn btn-crossword-input btn-primary ml-1" @click="fillInput">決定</button>
    </div>
</modal>`,

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  mounted: async function() {},

  beforeDestroy: function() {},

  computed: {},

  watch: {},

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    cancelInput: function() {
      this.$emit('closeclicked');
    },
    fillInput: function() {
      this.inputtext = this.inputtextstring.split('');
      this.$emit('fillinput', this.inputtext, this.questionnumber, this.questionnumber);
    },
  }
});

